export default {
  countryList: [
    {
      short: "AF",
      name: "阿富汗",
      en: "Afghanistan",
      tel: "93",
      pinyin: "afh",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "AL",
      name: "阿尔巴尼亚",
      en: "Albania",
      tel: "355",
      pinyin: "aebny",
      domain: "eu.iot.dreame.tech",
    },
    {
      short: "DZ",
      name: "阿尔及利亚",
      en: "Algeria",
      tel: "213",
      pinyin: "aejly",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "AS",
      name: "美属萨摩亚",
      en: "American Samoa",
      tel: "1684",
      pinyin: "mssmy",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "AD",
      name: "安道尔",
      en: "Andorra",
      tel: "376",
      pinyin: "ade",
      domain: "eu.iot.dreame.tech",
    },
    {
      short: "AO",
      name: "安哥拉",
      en: "Angola",
      tel: "244",
      pinyin: "agl",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "AI",
      name: "安圭拉",
      en: "Anguilla",
      tel: "1264",
      pinyin: "agl",
      domain: "us.iot.dreame.tech",
    },
    {
      short: "AG",
      name: "安提瓜和巴布达",
      en: "Antigua and Barbuda",
      tel: "1268",
      pinyin: "atghbbd",
      domain: "us.iot.dreame.tech",
    },
    {
      short: "AR",
      name: "阿根廷",
      en: "Argentina",
      tel: "54",
      pinyin: "agt",
      domain: "us.iot.dreame.tech",
    },
    {
      short: "AM",
      name: "亚美尼亚",
      en: "Armenia",
      tel: "374",
      pinyin: "ymny",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "AW",
      name: "阿鲁巴",
      en: "Aruba",
      tel: "297",
      pinyin: "alb",
      domain: "us.iot.dreame.tech",
    },
    {
      short: "AC",
      name: "阿森松岛",
      en: "Ascension Island",
      tel: "247",
      pinyin: "assd",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "AU",
      name: "澳大利亚",
      en: "Australia",
      tel: "61",
      pinyin: "adly",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "AT",
      name: "奥地利",
      en: "Austria",
      tel: "43",
      pinyin: "adl",
      domain: "eu.iot.dreame.tech",
    },
    {
      short: "AZ",
      name: "阿塞拜疆",
      en: "Azerbaijan",
      tel: "994",
      pinyin: "asbj",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "BS",
      name: "巴哈马",
      en: "Bahamas",
      tel: "1242",
      pinyin: "bhm",
      domain: "us.iot.dreame.tech",
    },
    {
      short: "BH",
      name: "巴林",
      en: "Bahrain",
      tel: "973",
      pinyin: "bl",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "BD",
      name: "孟加拉国",
      en: "Bangladesh",
      tel: "880",
      pinyin: "mjlg",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "BB",
      name: "巴巴多斯",
      en: "Barbados",
      tel: "1246",
      pinyin: "bbds",
      domain: "us.iot.dreame.tech",
    },
    {
      short: "BY",
      name: "白俄罗斯",
      en: "Belarus",
      tel: "375",
      pinyin: "bels",
      domain: "eu.iot.dreame.tech",
    },
    {
      short: "BE",
      name: "比利时",
      en: "Belgium",
      tel: "32",
      pinyin: "bls",
      domain: "eu.iot.dreame.tech",
    },
    {
      short: "BZ",
      name: "伯利兹",
      en: "Belize",
      tel: "501",
      pinyin: "blz",
      domain: "us.iot.dreame.tech",
    },
    {
      short: "BJ",
      name: "贝宁",
      en: "Benin",
      tel: "229",
      pinyin: "bn",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "BM",
      name: "百慕大",
      en: "Bermuda",
      tel: "1441",
      pinyin: "bmd",
      domain: "us.iot.dreame.tech",
    },
    {
      short: "BT",
      name: "不丹",
      en: "Bhutan",
      tel: "975",
      pinyin: "bd",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "BO",
      name: "玻利维亚",
      en: "Bolivia",
      tel: "591",
      pinyin: "blwy",
      domain: "us.iot.dreame.tech",
    },
    {
      short: "BA",
      name: "波黑",
      en: "Bosnia and Herzegovina",
      tel: "387",
      pinyin: "bh",
      domain: "eu.iot.dreame.tech",
    },
    {
      short: "BW",
      name: "博茨瓦纳",
      en: "Botswana",
      tel: "267",
      pinyin: "bcwn",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "BV",
      name: "布韦岛",
      en: "Bouvet Island",
      tel: "47",
      pinyin: "bwd",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "BR",
      name: "巴西",
      en: "Brazil",
      tel: "55",
      pinyin: "bx",
      domain: "us.iot.dreame.tech",
    },
    {
      short: "IO",
      name: "英属印度洋领地",
      en: "British Indian Ocean Territory",
      tel: "246",
      pinyin: "ysydyld",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "VG",
      name: "英属维尔京群岛",
      en: "British Virgin Islands",
      tel: "1284",
      pinyin: "yswejqd",
      domain: "us.iot.dreame.tech",
    },
    {
      short: "BN",
      name: "文莱",
      en: "Brunei Darussalam",
      tel: "673",
      pinyin: "wl",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "BG",
      name: "保加利亚",
      en: "Bulgaria",
      tel: "359",
      pinyin: "bjly",
      domain: "eu.iot.dreame.tech",
    },
    {
      short: "BF",
      name: "布基纳法索",
      en: "Burkina Faso",
      tel: "226",
      pinyin: "bjnfs",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "BI",
      name: "布隆迪",
      en: "Burundi",
      tel: "257",
      pinyin: "bld",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "KH",
      name: "柬埔寨",
      en: "Cambodia",
      tel: "855",
      pinyin: "jpz",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "CM",
      name: "喀麦隆",
      en: "Cameroon",
      tel: "237",
      pinyin: "kml",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "CA",
      name: "加拿大",
      en: "Canada",
      tel: "1",
      pinyin: "jnd",
      domain: "us.iot.dreame.tech",
    },
    {
      short: "IC",
      name: "加那利群岛",
      en: "Canary Islands",
      tel: "34",
      pinyin: "jnlqd",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "CV",
      name: "佛得角",
      en: "Cape Verde",
      tel: "238",
      pinyin: "fdj",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "BQ",
      name: "荷兰加勒比区",
      en: "Caribbean Netherlands",
      tel: "599",
      pinyin: "hljlbq",
      domain: "us.iot.dreame.tech",
    },
    {
      short: "KY",
      name: "开曼群岛",
      en: "Cayman Islands",
      tel: "1345",
      pinyin: "kmqd",
      domain: "us.iot.dreame.tech",
    },
    {
      short: "CF",
      name: "中非共和国",
      en: "Central African Republic",
      tel: "236",
      pinyin: "zfghg",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "EA",
      name: "休达及梅利利亚",
      en: "Ceuta and Melilla",
      tel: "34",
      pinyin: "xdjmlly",
      domain: "eu.iot.dreame.tech",
    },
    {
      short: "TD",
      name: "乍得",
      en: "Chad",
      tel: "235",
      pinyin: "zd",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "CL",
      name: "智利",
      en: "Chile",
      tel: "56",
      pinyin: "zl",
      domain: "us.iot.dreame.tech",
    },
    {
      short: "CN",
      name: "中国",
      en: "China",
      tel: "86",
      pinyin: "zg",
      domain: "cn.iot.dreame.tech",
    },
    {
      short: "CX",
      name: "圣诞岛",
      en: "Christmas Island",
      tel: "6189164",
      pinyin: "sdd",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "CC",
      name: "科科斯（基林）群岛",
      en: "Cocos (Keeling) Islands",
      tel: "6189162",
      pinyin: "kks（jl）qd",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "CO",
      name: "哥伦比亚",
      en: "Colombia",
      tel: "57",
      pinyin: "glby",
      domain: "us.iot.dreame.tech",
    },
    {
      short: "KM",
      name: "科摩罗",
      en: "Comoros",
      tel: "269",
      pinyin: "kml",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "CG",
      name: "刚果（布）",
      en: "Congo - Brazzaville",
      tel: "242",
      pinyin: "gg（b）",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "CD",
      name: "刚果（金）",
      en: "Congo - Kinshasa",
      tel: "243",
      pinyin: "gg（j）",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "CK",
      name: "库克群岛",
      en: "Cook Islands",
      tel: "682",
      pinyin: "kkqd",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "CR",
      name: "哥斯达黎加",
      en: "Costa Rica",
      tel: "506",
      pinyin: "gsdlj",
      domain: "us.iot.dreame.tech",
    },
    {
      short: "HR",
      name: "克罗地亚",
      en: "Croatia",
      tel: "385",
      pinyin: "kldy",
      domain: "eu.iot.dreame.tech",
    },
    {
      short: "CU",
      name: "古巴",
      en: "Cuba",
      tel: "53",
      pinyin: "gb",
      domain: "us.iot.dreame.tech",
    },
    {
      short: "CW",
      name: "库拉索",
      en: "Curaçao",
      tel: "5999",
      pinyin: "kls",
      domain: "us.iot.dreame.tech",
    },
    {
      short: "CY",
      name: "塞浦路斯",
      en: "Cyprus",
      tel: "357",
      pinyin: "spls",
      domain: "eu.iot.dreame.tech",
    },
    {
      short: "CZ",
      name: "捷克",
      en: "Czech Republic",
      tel: "420",
      pinyin: "jk",
      domain: "eu.iot.dreame.tech",
    },
    {
      short: "DK",
      name: "丹麦",
      en: "Denmark",
      tel: "45",
      pinyin: "dm",
      domain: "eu.iot.dreame.tech",
    },
    {
      short: "DG",
      name: "迪戈加西亚岛",
      en: "Diego Garcia",
      tel: "246",
      pinyin: "dgjxyd",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "DJ",
      name: "吉布提",
      en: "Djibouti",
      tel: "253",
      pinyin: "jbt",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "DM",
      name: "多米尼克",
      en: "Dominica",
      tel: "1767",
      pinyin: "dmnk",
      domain: "us.iot.dreame.tech",
    },
    {
      short: "DO",
      name: "多米尼加共和国",
      en: "Dominican Republic",
      tel: "1809",
      pinyin: "dmnjghg",
      domain: "us.iot.dreame.tech",
    },
    {
      short: "TL",
      name: "东帝汶",
      en: "East Timor (Timor-Leste)",
      tel: "670",
      pinyin: "ddw",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "EC",
      name: "厄瓜多尔",
      en: "Ecuador",
      tel: "593",
      pinyin: "egde",
      domain: "us.iot.dreame.tech",
    },
    {
      short: "EG",
      name: "埃及",
      en: "Egypt",
      tel: "20",
      pinyin: "aj",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "SV",
      name: "萨尔瓦多",
      en: "El Salvador",
      tel: "503",
      pinyin: "sewd",
      domain: "us.iot.dreame.tech",
    },
    {
      short: "GQ",
      name: "赤道几内亚",
      en: "Equatorial Guinea",
      tel: "240",
      pinyin: "cdjny",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "ER",
      name: "厄立特里亚",
      en: "Eritrea",
      tel: "291",
      pinyin: "eltly",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "EE",
      name: "爱沙尼亚",
      en: "Estonia",
      tel: "372",
      pinyin: "asny",
      domain: "eu.iot.dreame.tech",
    },
    {
      short: "ET",
      name: "埃塞俄比亚",
      en: "Ethiopia",
      tel: "251",
      pinyin: "aseby",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "FK",
      name: "福克兰群岛",
      en: "Falkland Islands",
      tel: "500",
      pinyin: "fklqd",
      domain: "us.iot.dreame.tech",
    },
    {
      short: "FO",
      name: "法罗群岛",
      en: "Faroe Islands",
      tel: "298",
      pinyin: "flqd",
      domain: "eu.iot.dreame.tech",
    },
    {
      short: "FJ",
      name: "斐济",
      en: "Fiji",
      tel: "679",
      pinyin: "fj",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "FI",
      name: "芬兰",
      en: "Finland",
      tel: "358",
      pinyin: "fl",
      domain: "eu.iot.dreame.tech",
    },
    {
      short: "FR",
      name: "法国",
      en: "France",
      tel: "33",
      pinyin: "fg",
      domain: "eu.iot.dreame.tech",
    },
    {
      short: "GF",
      name: "法属圭亚那",
      en: "French Guiana",
      tel: "594",
      pinyin: "fsgyn",
      domain: "eu.iot.dreame.tech",
    },
    {
      short: "PF",
      name: "法属波利尼西亚",
      en: "French polynesia",
      tel: "689",
      pinyin: "fsblnxy",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "TF",
      name: "法属南部领地",
      en: "French Southern Territories",
      tel: "262",
      pinyin: "fsnbld",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "GA",
      name: "加蓬",
      en: "Gabon",
      tel: "241",
      pinyin: "jp",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "GM",
      name: "冈比亚",
      en: "Gambia",
      tel: "220",
      pinyin: "gby",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "GE",
      name: "格鲁吉亚",
      en: "Georgia",
      tel: "995",
      pinyin: "gljy",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "DE",
      name: "德国",
      en: "Germany",
      tel: "49",
      pinyin: "dg",
      domain: "eu.iot.dreame.tech",
    },
    {
      short: "GH",
      name: "加纳",
      en: "Ghana",
      tel: "233",
      pinyin: "jn",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "GI",
      name: "直布罗陀",
      en: "Gibraltar",
      tel: "350",
      pinyin: "zblt",
      domain: "eu.iot.dreame.tech",
    },
    {
      short: "GR",
      name: "希腊",
      en: "Greece",
      tel: "30",
      pinyin: "xl",
      domain: "eu.iot.dreame.tech",
    },
    {
      short: "GL",
      name: "格陵兰",
      en: "Greenland",
      tel: "299",
      pinyin: "gll",
      domain: "us.iot.dreame.tech",
    },
    {
      short: "GD",
      name: "格林纳达",
      en: "Grenada",
      tel: "1473",
      pinyin: "glnd",
      domain: "us.iot.dreame.tech",
    },
    {
      short: "GP",
      name: "瓜德罗普",
      en: "Guadeloupe",
      tel: "590",
      pinyin: "gdlp",
      domain: "us.iot.dreame.tech",
    },
    {
      short: "GU",
      name: "关岛",
      en: "Guam",
      tel: "1671",
      pinyin: "gd",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "GT",
      name: "危地马拉",
      en: "Guatemala",
      tel: "502",
      pinyin: "wdml",
      domain: "us.iot.dreame.tech",
    },
    {
      short: "GG",
      name: "根西岛",
      en: "Guernsey",
      tel: "447781",
      pinyin: "gxd",
      domain: "eu.iot.dreame.tech",
    },
    {
      short: "GN",
      name: "几内亚",
      en: "Guinea",
      tel: "224",
      pinyin: "jny",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "GW",
      name: "几内亚比绍",
      en: "Guinea-Bissau",
      tel: "245",
      pinyin: "jnybs",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "GY",
      name: "圭亚那",
      en: "Guyana",
      tel: "592",
      pinyin: "gyn",
      domain: "us.iot.dreame.tech",
    },
    {
      short: "HT",
      name: "海地",
      en: "Haiti",
      tel: "509",
      pinyin: "hd",
      domain: "us.iot.dreame.tech",
    },
    {
      short: "HN",
      name: "洪都拉斯",
      en: "Honduras",
      tel: "504",
      pinyin: "hdls",
      domain: "us.iot.dreame.tech",
    },
    {
      short: "HK",
      name: "中国香港特别行政区",
      en: "Hong Kong（China）",
      tel: "852",
      pinyin: "zgxgtbhzq",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "HU",
      name: "匈牙利",
      en: "Hungary",
      tel: "36",
      pinyin: "xyl",
      domain: "eu.iot.dreame.tech",
    },
    {
      short: "IS",
      name: "冰岛",
      en: "Iceland",
      tel: "354",
      pinyin: "bd",
      domain: "eu.iot.dreame.tech",
    },
    {
      short: "IN",
      name: "印度",
      en: "India",
      tel: "91",
      pinyin: "yd",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "ID",
      name: "印度尼西亚",
      en: "Indonesia",
      tel: "62",
      pinyin: "ydnxy",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "IR",
      name: "伊朗",
      en: "Iran",
      tel: "98",
      pinyin: "yl",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "IQ",
      name: "伊拉克",
      en: "Iraq",
      tel: "964",
      pinyin: "ylk",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "IE",
      name: "爱尔兰",
      en: "Ireland",
      tel: "353",
      pinyin: "ael",
      domain: "eu.iot.dreame.tech",
    },
    {
      short: "IM",
      name: "马恩岛",
      en: "Isle of Man",
      tel: "447624",
      pinyin: "med",
      domain: "eu.iot.dreame.tech",
    },
    {
      short: "IL",
      name: "以色列",
      en: "Israel",
      tel: "972",
      pinyin: "ysl",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "IT",
      name: "意大利",
      en: "Italy",
      tel: "39",
      pinyin: "ydl",
      domain: "eu.iot.dreame.tech",
    },
    {
      short: "CI",
      name: "科特迪瓦",
      en: "Ivory Coast (Côte d'Ivoire)",
      tel: "225",
      pinyin: "ktdw",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "JM",
      name: "牙买加",
      en: "Jamaica",
      tel: "1876",
      pinyin: "ymj",
      domain: "us.iot.dreame.tech",
    },
    {
      short: "JP",
      name: "日本",
      en: "Japan",
      tel: "81",
      pinyin: "rb",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "JE",
      name: "泽西岛",
      en: "Jersey",
      tel: "441534",
      pinyin: "zxd",
      domain: "eu.iot.dreame.tech",
    },
    {
      short: "JO",
      name: "约旦",
      en: "Jordan",
      tel: "962",
      pinyin: "yd",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "KZ",
      name: "哈萨克斯坦",
      en: "Kazakhstan",
      tel: "77",
      pinyin: "hskst",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "KE",
      name: "肯尼亚",
      en: "Kenya",
      tel: "254",
      pinyin: "kny",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "KI",
      name: "基里巴斯",
      en: "Kiribati",
      tel: "686",
      pinyin: "jlbs",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "XK",
      name: "科索沃",
      en: "Kosovo",
      tel: "383",
      pinyin: "ksw",
      domain: "eu.iot.dreame.tech",
    },
    {
      short: "KW",
      name: "科威特",
      en: "Kuwait",
      tel: "965",
      pinyin: "kwt",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "KG",
      name: "吉尔吉斯斯坦",
      en: "Kyrgyzstan",
      tel: "996",
      pinyin: "jejsst",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "LA",
      name: "老挝",
      en: "Laos",
      tel: "856",
      pinyin: "lz",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "LV",
      name: "拉脱维亚",
      en: "Latvia",
      tel: "371",
      pinyin: "ltwy",
      domain: "eu.iot.dreame.tech",
    },
    {
      short: "LB",
      name: "黎巴嫩",
      en: "Lebanon",
      tel: "961",
      pinyin: "lbn",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "LS",
      name: "莱索托",
      en: "Lesotho",
      tel: "266",
      pinyin: "lst",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "LR",
      name: "利比里亚",
      en: "Liberia",
      tel: "231",
      pinyin: "lbly",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "LY",
      name: "利比亚",
      en: "Libya",
      tel: "218",
      pinyin: "lby",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "LI",
      name: "列支敦士登",
      en: "Liechtenstein",
      tel: "423",
      pinyin: "lzdsd",
      domain: "eu.iot.dreame.tech",
    },
    {
      short: "LT",
      name: "立陶宛",
      en: "Lithuania",
      tel: "370",
      pinyin: "ltw",
      domain: "eu.iot.dreame.tech",
    },
    {
      short: "LU",
      name: "卢森堡",
      en: "Luxembourg",
      tel: "352",
      pinyin: "lsb",
      domain: "eu.iot.dreame.tech",
    },
    {
      short: "MO",
      name: "中国澳门特别行政区",
      en: "Macau (China)",
      tel: "853",
      pinyin: "zgamtbhzq",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "MG",
      name: "马达加斯加",
      en: "Madagascar",
      tel: "261",
      pinyin: "mdjsj",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "MW",
      name: "马拉维",
      en: "Malawi",
      tel: "265",
      pinyin: "mlw",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "MY",
      name: "马来西亚",
      en: "Malaysia",
      tel: "60",
      pinyin: "mlxy",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "MV",
      name: "马尔代夫",
      en: "Maldives",
      tel: "960",
      pinyin: "medf",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "ML",
      name: "马里",
      en: "Mali",
      tel: "223",
      pinyin: "ml",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "MT",
      name: "马耳他",
      en: "Malta",
      tel: "356",
      pinyin: "met",
      domain: "eu.iot.dreame.tech",
    },
    {
      short: "MH",
      name: "马绍尔群岛",
      en: "Marshall islands",
      tel: "692",
      pinyin: "mseqd",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "MQ",
      name: "马提尼克",
      en: "Martinique",
      tel: "596",
      pinyin: "mtnk",
      domain: "us.iot.dreame.tech",
    },
    {
      short: "MR",
      name: "毛里塔尼亚",
      en: "Mauritania",
      tel: "222",
      pinyin: "mltny",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "MU",
      name: "毛里求斯",
      en: "Mauritius",
      tel: "230",
      pinyin: "mlqs",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "YT",
      name: "马约特",
      en: "Mayotte",
      tel: "262639",
      pinyin: "myt",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "MX",
      name: "墨西哥",
      en: "Mexico",
      tel: "52",
      pinyin: "mxg",
      domain: "us.iot.dreame.tech",
    },
    {
      short: "FM",
      name: "密克罗尼西亚",
      en: "Micronesia",
      tel: "691",
      pinyin: "mklnxy",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "MD",
      name: "摩尔多瓦",
      en: "Moldova",
      tel: "373",
      pinyin: "medw",
      domain: "eu.iot.dreame.tech",
    },
    {
      short: "MC",
      name: "摩纳哥",
      en: "Monaco",
      tel: "377",
      pinyin: "mng",
      domain: "eu.iot.dreame.tech",
    },
    {
      short: "MN",
      name: "蒙古",
      en: "Mongolia",
      tel: "976",
      pinyin: "mg",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "ME",
      name: "黑山",
      en: "Montenegro",
      tel: "382",
      pinyin: "hs",
      domain: "eu.iot.dreame.tech",
    },
    {
      short: "MS",
      name: "蒙特塞拉特",
      en: "Montserrat",
      tel: "1664",
      pinyin: "mtslt",
      domain: "us.iot.dreame.tech",
    },
    {
      short: "MA",
      name: "摩洛哥",
      en: "Morocco",
      tel: "212",
      pinyin: "mlg",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "MZ",
      name: "莫桑比克",
      en: "Mozambique",
      tel: "258",
      pinyin: "msbk",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "MM",
      name: "缅甸",
      en: "Myanmar (Burma)",
      tel: "95",
      pinyin: "md",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "NA",
      name: "纳米比亚",
      en: "Namibia",
      tel: "264",
      pinyin: "nmby",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "NR",
      name: "瑙鲁",
      en: "Nauru",
      tel: "674",
      pinyin: "nl",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "NP",
      name: "尼泊尔",
      en: "Nepal",
      tel: "977",
      pinyin: "nbe",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "NL",
      name: "荷兰",
      en: "Netherlands",
      tel: "31",
      pinyin: "hl",
      domain: "eu.iot.dreame.tech",
    },
    {
      short: "NC",
      name: "新喀里多尼亚",
      en: "New Caledonia",
      tel: "687",
      pinyin: "xkldny",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "NZ",
      name: "新西兰",
      en: "New Zealand",
      tel: "64",
      pinyin: "xxl",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "NI",
      name: "尼加拉瓜",
      en: "Nicaragua",
      tel: "505",
      pinyin: "njlg",
      domain: "us.iot.dreame.tech",
    },
    {
      short: "NE",
      name: "尼日尔",
      en: "Niger",
      tel: "227",
      pinyin: "nre",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "NG",
      name: "尼日利亚",
      en: "Nigeria",
      tel: "234",
      pinyin: "nrly",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "NU",
      name: "纽埃",
      en: "Niue",
      tel: "683",
      pinyin: "na",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "NF",
      name: "诺福克岛",
      en: "Norfolk Island",
      tel: "6723",
      pinyin: "nfkd",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "KP",
      name: "朝鲜",
      en: "North Korea",
      tel: "850",
      pinyin: "zx",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "MK",
      name: "马其顿",
      en: "North Macedonia",
      tel: "389",
      pinyin: "mqd",
      domain: "eu.iot.dreame.tech",
    },
    {
      short: "MP",
      name: "北马里亚纳群岛",
      en: "Northern Mariana Islands",
      tel: "1670",
      pinyin: "bmlynqd",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "NO",
      name: "挪威",
      en: "Norway",
      tel: "47",
      pinyin: "nw",
      domain: "eu.iot.dreame.tech",
    },
    {
      short: "OM",
      name: "阿曼",
      en: "Oman",
      tel: "968",
      pinyin: "am",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "PK",
      name: "巴基斯坦",
      en: "Pakistan",
      tel: "92",
      pinyin: "bjst",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "PW",
      name: "帕劳",
      en: "Palau",
      tel: "680",
      pinyin: "pl",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "PS",
      name: "巴勒斯坦",
      en: "Palestinian Territories",
      tel: "970",
      pinyin: "blst",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "PA",
      name: "巴拿马",
      en: "Panama",
      tel: "507",
      pinyin: "bnm",
      domain: "us.iot.dreame.tech",
    },
    {
      short: "PG",
      name: "巴布亚新几内亚",
      en: "Papua New Guinea",
      tel: "675",
      pinyin: "bbyxjny",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "PY",
      name: "巴拉圭",
      en: "Paraguay",
      tel: "595",
      pinyin: "blg",
      domain: "us.iot.dreame.tech",
    },
    {
      short: "PE",
      name: "秘鲁",
      en: "Peru",
      tel: "51",
      pinyin: "ml",
      domain: "us.iot.dreame.tech",
    },
    {
      short: "PH",
      name: "菲律宾",
      en: "Philippines",
      tel: "63",
      pinyin: "flb",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "PN",
      name: "皮特凯恩群岛",
      en: "Pitcairn Islands",
      tel: "64",
      pinyin: "ptkeqd",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "PL",
      name: "波兰",
      en: "Poland",
      tel: "48",
      pinyin: "bl",
      domain: "eu.iot.dreame.tech",
    },
    {
      short: "PT",
      name: "葡萄牙",
      en: "Portugal",
      tel: "351",
      pinyin: "pty",
      domain: "eu.iot.dreame.tech",
    },
    {
      short: "PR",
      name: "波多黎各",
      en: "Puerto Rico",
      tel: "1939",
      pinyin: "bdlg",
      domain: "us.iot.dreame.tech",
    },
    {
      short: "QA",
      name: "卡塔尔",
      en: "Qatar",
      tel: "974",
      pinyin: "kte",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "RO",
      name: "罗马尼亚",
      en: "Romania",
      tel: "40",
      pinyin: "lmny",
      domain: "eu.iot.dreame.tech",
    },
    {
      short: "RU",
      name: "俄罗斯",
      en: "Russia",
      tel: "7",
      pinyin: "els",
      domain: "ru.iot.dreame.tech",
    },
    {
      short: "RW",
      name: "卢旺达",
      en: "Rwanda",
      tel: "250",
      pinyin: "lwd",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "RE",
      name: "留尼汪",
      en: "Réunion",
      tel: "262",
      pinyin: "lnw",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "BL",
      name: "圣巴泰勒米",
      en: "Saint Barthélemy",
      tel: "590",
      pinyin: "sbtlm",
      domain: "us.iot.dreame.tech",
    },
    {
      short: "SH",
      name: "圣赫勒拿",
      en: "Saint Helena",
      tel: "290",
      pinyin: "shln",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "KN",
      name: "圣基茨和尼维斯",
      en: "Saint Kitts and Nevis",
      tel: "1869",
      pinyin: "sjchnws",
      domain: "us.iot.dreame.tech",
    },
    {
      short: "LC",
      name: "圣卢西亚",
      en: "Saint Lucia",
      tel: "1758",
      pinyin: "slxy",
      domain: "us.iot.dreame.tech",
    },
    {
      short: "MF",
      name: "法属圣马丁",
      en: "Saint Martin (France)",
      tel: "590",
      pinyin: "fssmd",
      domain: "eu.iot.dreame.tech",
    },
    {
      short: "PM",
      name: "圣皮埃尔和密克隆群岛",
      en: "Saint Pierre and Miquelon",
      tel: "508",
      pinyin: "spaehmklqd",
      domain: "us.iot.dreame.tech",
    },
    {
      short: "VC",
      name: "圣文森特和格林纳丁斯",
      en: "Saint Vincent and The Grenadines",
      tel: "1784",
      pinyin: "swsthglnds",
      domain: "us.iot.dreame.tech",
    },
    {
      short: "WS",
      name: "萨摩亚",
      en: "Samoa",
      tel: "685",
      pinyin: "smy",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "SM",
      name: "圣马力诺",
      en: "San Marino",
      tel: "378",
      pinyin: "smln",
      domain: "eu.iot.dreame.tech",
    },
    {
      short: "SA",
      name: "沙特阿拉伯",
      en: "Saudi Arabia",
      tel: "966",
      pinyin: "stalb",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "SN",
      name: "塞内加尔",
      en: "Senegal",
      tel: "221",
      pinyin: "snje",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "RS",
      name: "塞尔维亚",
      en: "Serbia",
      tel: "381",
      pinyin: "sewy",
      domain: "eu.iot.dreame.tech",
    },
    {
      short: "SC",
      name: "塞舌尔",
      en: "Seychelles",
      tel: "248",
      pinyin: "sse",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "SL",
      name: "塞拉利昂",
      en: "Sierra Leone",
      tel: "232",
      pinyin: "slla",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "SG",
      name: "新加坡",
      en: "Singapore",
      tel: "65",
      pinyin: "xjp",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "SK",
      name: "斯洛伐克",
      en: "Slovakia",
      tel: "421",
      pinyin: "slfk",
      domain: "eu.iot.dreame.tech",
    },
    {
      short: "SI",
      name: "斯洛文尼亚",
      en: "Slovenia",
      tel: "386",
      pinyin: "slwny",
      domain: "eu.iot.dreame.tech",
    },
    {
      short: "SB",
      name: "所罗门群岛",
      en: "Solomon Islands",
      tel: "677",
      pinyin: "slmqd",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "SO",
      name: "索马里",
      en: "Somalia",
      tel: "252",
      pinyin: "sml",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "ZA",
      name: "南非",
      en: "South Africa",
      tel: "27",
      pinyin: "nf",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "GS",
      name: "南乔治亚和南桑威奇群岛",
      en: "South Georgia and the South Sandwich Islands",
      tel: "500",
      pinyin: "nqzyhnswqqd",
      domain: "us.iot.dreame.tech",
    },
    {
      short: "KR",
      name: "韩国",
      en: "South Korea",
      tel: "82",
      pinyin: "hg",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "SS",
      name: "南苏丹",
      en: "South Sudan",
      tel: "211",
      pinyin: "nsd",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "ES",
      name: "西班牙",
      en: "Spain",
      tel: "34",
      pinyin: "xby",
      domain: "eu.iot.dreame.tech",
    },
    {
      short: "LK",
      name: "斯里兰卡",
      en: "Sri Lanka",
      tel: "94",
      pinyin: "sllk",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "SD",
      name: "苏丹",
      en: "Sudan",
      tel: "249",
      pinyin: "sd",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "SR",
      name: "苏里南",
      en: "Suriname",
      tel: "597",
      pinyin: "sln",
      domain: "us.iot.dreame.tech",
    },
    {
      short: "SJ",
      name: "斯瓦尔巴和扬马延",
      en: "Svalbard and Jan Mayen",
      tel: "4779",
      pinyin: "swebhymy",
      domain: "eu.iot.dreame.tech",
    },
    {
      short: "SZ",
      name: "斯威士兰",
      en: "Swaziland",
      tel: "268",
      pinyin: "swsl",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "SE",
      name: "瑞典",
      en: "Sweden",
      tel: "46",
      pinyin: "rd",
      domain: "eu.iot.dreame.tech",
    },
    {
      short: "CH",
      name: "瑞士",
      en: "Switzerland",
      tel: "41",
      pinyin: "rs",
      domain: "eu.iot.dreame.tech",
    },
    {
      short: "SY",
      name: "叙利亚",
      en: "Syria",
      tel: "963",
      pinyin: "xly",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "ST",
      name: "圣多美和普林西比",
      en: "São Tomé and Príncipe",
      tel: "239",
      pinyin: "sdmhplxb",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "TW",
      name: "中国台湾",
      en: "Taiwan (China)",
      tel: "886",
      pinyin: "zgtw",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "TJ",
      name: "塔吉克斯坦",
      en: "Tajikistan",
      tel: "992",
      pinyin: "tjkst",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "TZ",
      name: "坦桑尼亚",
      en: "Tanzania",
      tel: "255",
      pinyin: "tsny",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "TH",
      name: "泰国",
      en: "Thailand",
      tel: "66",
      pinyin: "tg",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "TG",
      name: "多哥",
      en: "Togo",
      tel: "228",
      pinyin: "dg",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "TK",
      name: "托克劳",
      en: "Tokelau",
      tel: "690",
      pinyin: "tkl",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "TO",
      name: "汤加",
      en: "Tonga",
      tel: "676",
      pinyin: "tj",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "TT",
      name: "特立尼达和多巴哥",
      en: "Trinidad and Tobago",
      tel: "1868",
      pinyin: "tlndhdbg",
      domain: "us.iot.dreame.tech",
    },
    {
      short: "TA",
      name: "特里斯坦-达库尼亚群岛",
      en: "Tristan da Cunha",
      tel: "290",
      pinyin: "tlstdknyqd",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "TN",
      name: "突尼斯",
      en: "Tunisia",
      tel: "216",
      pinyin: "tns",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "TR",
      name: "土耳其",
      en: "Turkey",
      tel: "90",
      pinyin: "teq",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "TM",
      name: "土库曼斯坦",
      en: "Turkmenistan",
      tel: "993",
      pinyin: "tkmst",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "TC",
      name: "特克斯和凯科斯群岛",
      en: "Turks and Caicos Islands",
      tel: "1649",
      pinyin: "tkshkksqd",
      domain: "us.iot.dreame.tech",
    },
    {
      short: "TV",
      name: "图瓦卢",
      en: "Tuvalu",
      tel: "688",
      pinyin: "twl",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "UG",
      name: "乌干达",
      en: "Uganda",
      tel: "256",
      pinyin: "wgd",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "UA",
      name: "乌克兰",
      en: "Ukraine",
      tel: "380",
      pinyin: "wkl",
      domain: "eu.iot.dreame.tech",
    },
    {
      short: "AE",
      name: "阿拉伯联合酋长国",
      en: "United Arab Emirates",
      tel: "971",
      pinyin: "alblhqcg",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "GB",
      name: "英国",
      en: "United Kingdom",
      tel: "44",
      pinyin: "yg",
      domain: "eu.iot.dreame.tech",
    },
    {
      short: "US",
      name: "美国",
      en: "United States",
      tel: "1",
      pinyin: "mg",
      domain: "us.iot.dreame.tech",
    },
    {
      short: "UM",
      name: "美国本土外小岛屿",
      en: "United States Minor Outlying Islands",
      tel: "1",
      pinyin: "mgbtwxdy",
      domain: "us.iot.dreame.tech",
    },
    {
      short: "UY",
      name: "乌拉圭",
      en: "Uruguay",
      tel: "598",
      pinyin: "wlg",
      domain: "us.iot.dreame.tech",
    },
    {
      short: "VI",
      name: "美属维尔京群岛",
      en: "US Virgin Islands",
      tel: "1340",
      pinyin: "mswejqd",
      domain: "us.iot.dreame.tech",
    },
    {
      short: "UZ",
      name: "乌兹别克斯坦",
      en: "Uzbekistan",
      tel: "998",
      pinyin: "wzbkst",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "VU",
      name: "瓦努阿图",
      en: "Vanuatu",
      tel: "678",
      pinyin: "wnat",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "VA",
      name: "梵蒂冈",
      en: "Vatican",
      tel: "3906",
      pinyin: "fdg",
      domain: "eu.iot.dreame.tech",
    },
    {
      short: "VE",
      name: "委内瑞拉",
      en: "Venezuela",
      tel: "58",
      pinyin: "wnrl",
      domain: "us.iot.dreame.tech",
    },
    {
      short: "VN",
      name: "越南",
      en: "Vietnam",
      tel: "84",
      pinyin: "yn",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "WF",
      name: "瓦利斯和富图纳",
      en: "Wallis and Futuna",
      tel: "681",
      pinyin: "wlshftn",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "EH",
      name: "西撒哈拉",
      en: "Western Sahara",
      tel: "212",
      pinyin: "xshl",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "YE",
      name: "也门",
      en: "Yemen",
      tel: "967",
      pinyin: "ym",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "ZM",
      name: "赞比亚",
      en: "Zambia",
      tel: "260",
      pinyin: "zby",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "ZW",
      name: "津巴布韦",
      en: "Zimbabwe",
      tel: "263",
      pinyin: "jbbw",
      domain: "sg.iot.dreame.tech",
    },
    {
      short: "AX",
      name: "奥兰群岛",
      en: "Åland Islands",
      tel: "35818",
      pinyin: "alqd",
      domain: "eu.iot.dreame.tech",
    },
  ],
  letterList: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"],
  convertCountry: [
    [
      {
        short: "AF",
        name: "阿富汗",
        en: "Afghanistan",
        tel: "93",
        pinyin: "afh",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "AL",
        name: "阿尔巴尼亚",
        en: "Albania",
        tel: "355",
        pinyin: "aebny",
        domain: "eu.iot.dreame.tech",
      },
      {
        short: "DZ",
        name: "阿尔及利亚",
        en: "Algeria",
        tel: "213",
        pinyin: "aejly",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "AS",
        name: "美属萨摩亚",
        en: "American Samoa",
        tel: "1684",
        pinyin: "mssmy",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "AD",
        name: "安道尔",
        en: "Andorra",
        tel: "376",
        pinyin: "ade",
        domain: "eu.iot.dreame.tech",
      },
      {
        short: "AO",
        name: "安哥拉",
        en: "Angola",
        tel: "244",
        pinyin: "agl",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "AI",
        name: "安圭拉",
        en: "Anguilla",
        tel: "1264",
        pinyin: "agl",
        domain: "us.iot.dreame.tech",
      },
      {
        short: "AG",
        name: "安提瓜和巴布达",
        en: "Antigua and Barbuda",
        tel: "1268",
        pinyin: "atghbbd",
        domain: "us.iot.dreame.tech",
      },
      {
        short: "AR",
        name: "阿根廷",
        en: "Argentina",
        tel: "54",
        pinyin: "agt",
        domain: "us.iot.dreame.tech",
      },
      {
        short: "AM",
        name: "亚美尼亚",
        en: "Armenia",
        tel: "374",
        pinyin: "ymny",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "AW",
        name: "阿鲁巴",
        en: "Aruba",
        tel: "297",
        pinyin: "alb",
        domain: "us.iot.dreame.tech",
      },
      {
        short: "AC",
        name: "阿森松岛",
        en: "Ascension Island",
        tel: "247",
        pinyin: "assd",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "AU",
        name: "澳大利亚",
        en: "Australia",
        tel: "61",
        pinyin: "adly",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "AT",
        name: "奥地利",
        en: "Austria",
        tel: "43",
        pinyin: "adl",
        domain: "eu.iot.dreame.tech",
      },
      {
        short: "AZ",
        name: "阿塞拜疆",
        en: "Azerbaijan",
        tel: "994",
        pinyin: "asbj",
        domain: "sg.iot.dreame.tech",
      },
    ],
    [
      {
        short: "BS",
        name: "巴哈马",
        en: "Bahamas",
        tel: "1242",
        pinyin: "bhm",
        domain: "us.iot.dreame.tech",
      },
      {
        short: "BH",
        name: "巴林",
        en: "Bahrain",
        tel: "973",
        pinyin: "bl",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "BD",
        name: "孟加拉国",
        en: "Bangladesh",
        tel: "880",
        pinyin: "mjlg",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "BB",
        name: "巴巴多斯",
        en: "Barbados",
        tel: "1246",
        pinyin: "bbds",
        domain: "us.iot.dreame.tech",
      },
      {
        short: "BY",
        name: "白俄罗斯",
        en: "Belarus",
        tel: "375",
        pinyin: "bels",
        domain: "eu.iot.dreame.tech",
      },
      {
        short: "BE",
        name: "比利时",
        en: "Belgium",
        tel: "32",
        pinyin: "bls",
        domain: "eu.iot.dreame.tech",
      },
      {
        short: "BZ",
        name: "伯利兹",
        en: "Belize",
        tel: "501",
        pinyin: "blz",
        domain: "us.iot.dreame.tech",
      },
      {
        short: "BJ",
        name: "贝宁",
        en: "Benin",
        tel: "229",
        pinyin: "bn",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "BM",
        name: "百慕大",
        en: "Bermuda",
        tel: "1441",
        pinyin: "bmd",
        domain: "us.iot.dreame.tech",
      },
      {
        short: "BT",
        name: "不丹",
        en: "Bhutan",
        tel: "975",
        pinyin: "bd",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "BO",
        name: "玻利维亚",
        en: "Bolivia",
        tel: "591",
        pinyin: "blwy",
        domain: "us.iot.dreame.tech",
      },
      {
        short: "BA",
        name: "波黑",
        en: "Bosnia and Herzegovina",
        tel: "387",
        pinyin: "bh",
        domain: "eu.iot.dreame.tech",
      },
      {
        short: "BW",
        name: "博茨瓦纳",
        en: "Botswana",
        tel: "267",
        pinyin: "bcwn",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "BV",
        name: "布韦岛",
        en: "Bouvet Island",
        tel: "47",
        pinyin: "bwd",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "BR",
        name: "巴西",
        en: "Brazil",
        tel: "55",
        pinyin: "bx",
        domain: "us.iot.dreame.tech",
      },
      {
        short: "IO",
        name: "英属印度洋领地",
        en: "British Indian Ocean Territory",
        tel: "246",
        pinyin: "ysydyld",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "VG",
        name: "英属维尔京群岛",
        en: "British Virgin Islands",
        tel: "1284",
        pinyin: "yswejqd",
        domain: "us.iot.dreame.tech",
      },
      {
        short: "BN",
        name: "文莱",
        en: "Brunei Darussalam",
        tel: "673",
        pinyin: "wl",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "BG",
        name: "保加利亚",
        en: "Bulgaria",
        tel: "359",
        pinyin: "bjly",
        domain: "eu.iot.dreame.tech",
      },
      {
        short: "BF",
        name: "布基纳法索",
        en: "Burkina Faso",
        tel: "226",
        pinyin: "bjnfs",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "BI",
        name: "布隆迪",
        en: "Burundi",
        tel: "257",
        pinyin: "bld",
        domain: "sg.iot.dreame.tech",
      },
    ],
    [
      {
        short: "KH",
        name: "柬埔寨",
        en: "Cambodia",
        tel: "855",
        pinyin: "jpz",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "CM",
        name: "喀麦隆",
        en: "Cameroon",
        tel: "237",
        pinyin: "kml",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "CA",
        name: "加拿大",
        en: "Canada",
        tel: "1",
        pinyin: "jnd",
        domain: "us.iot.dreame.tech",
      },
      {
        short: "IC",
        name: "加那利群岛",
        en: "Canary Islands",
        tel: "34",
        pinyin: "jnlqd",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "CV",
        name: "佛得角",
        en: "Cape Verde",
        tel: "238",
        pinyin: "fdj",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "BQ",
        name: "荷兰加勒比区",
        en: "Caribbean Netherlands",
        tel: "599",
        pinyin: "hljlbq",
        domain: "us.iot.dreame.tech",
      },
      {
        short: "KY",
        name: "开曼群岛",
        en: "Cayman Islands",
        tel: "1345",
        pinyin: "kmqd",
        domain: "us.iot.dreame.tech",
      },
      {
        short: "CF",
        name: "中非共和国",
        en: "Central African Republic",
        tel: "236",
        pinyin: "zfghg",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "EA",
        name: "休达及梅利利亚",
        en: "Ceuta and Melilla",
        tel: "34",
        pinyin: "xdjmlly",
        domain: "eu.iot.dreame.tech",
      },
      {
        short: "TD",
        name: "乍得",
        en: "Chad",
        tel: "235",
        pinyin: "zd",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "CL",
        name: "智利",
        en: "Chile",
        tel: "56",
        pinyin: "zl",
        domain: "us.iot.dreame.tech",
      },
      {
        short: "CN",
        name: "中国",
        en: "China",
        tel: "86",
        pinyin: "zg",
        domain: "cn.iot.dreame.tech",
      },
      {
        short: "CX",
        name: "圣诞岛",
        en: "Christmas Island",
        tel: "6189164",
        pinyin: "sdd",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "CC",
        name: "科科斯（基林）群岛",
        en: "Cocos (Keeling) Islands",
        tel: "6189162",
        pinyin: "kks（jl）qd",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "CO",
        name: "哥伦比亚",
        en: "Colombia",
        tel: "57",
        pinyin: "glby",
        domain: "us.iot.dreame.tech",
      },
      {
        short: "KM",
        name: "科摩罗",
        en: "Comoros",
        tel: "269",
        pinyin: "kml",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "CG",
        name: "刚果（布）",
        en: "Congo - Brazzaville",
        tel: "242",
        pinyin: "gg（b）",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "CD",
        name: "刚果（金）",
        en: "Congo - Kinshasa",
        tel: "243",
        pinyin: "gg（j）",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "CK",
        name: "库克群岛",
        en: "Cook Islands",
        tel: "682",
        pinyin: "kkqd",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "CR",
        name: "哥斯达黎加",
        en: "Costa Rica",
        tel: "506",
        pinyin: "gsdlj",
        domain: "us.iot.dreame.tech",
      },
      {
        short: "HR",
        name: "克罗地亚",
        en: "Croatia",
        tel: "385",
        pinyin: "kldy",
        domain: "eu.iot.dreame.tech",
      },
      {
        short: "CU",
        name: "古巴",
        en: "Cuba",
        tel: "53",
        pinyin: "gb",
        domain: "us.iot.dreame.tech",
      },
      {
        short: "CW",
        name: "库拉索",
        en: "Curaçao",
        tel: "5999",
        pinyin: "kls",
        domain: "us.iot.dreame.tech",
      },
      {
        short: "CY",
        name: "塞浦路斯",
        en: "Cyprus",
        tel: "357",
        pinyin: "spls",
        domain: "eu.iot.dreame.tech",
      },
      {
        short: "CZ",
        name: "捷克",
        en: "Czech Republic",
        tel: "420",
        pinyin: "jk",
        domain: "eu.iot.dreame.tech",
      },
    ],
    [
      {
        short: "DK",
        name: "丹麦",
        en: "Denmark",
        tel: "45",
        pinyin: "dm",
        domain: "eu.iot.dreame.tech",
      },
      {
        short: "DG",
        name: "迪戈加西亚岛",
        en: "Diego Garcia",
        tel: "246",
        pinyin: "dgjxyd",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "DJ",
        name: "吉布提",
        en: "Djibouti",
        tel: "253",
        pinyin: "jbt",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "DM",
        name: "多米尼克",
        en: "Dominica",
        tel: "1767",
        pinyin: "dmnk",
        domain: "us.iot.dreame.tech",
      },
      {
        short: "DO",
        name: "多米尼加共和国",
        en: "Dominican Republic",
        tel: "1809",
        pinyin: "dmnjghg",
        domain: "us.iot.dreame.tech",
      },
    ],
    [
      {
        short: "TL",
        name: "东帝汶",
        en: "East Timor (Timor-Leste)",
        tel: "670",
        pinyin: "ddw",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "EC",
        name: "厄瓜多尔",
        en: "Ecuador",
        tel: "593",
        pinyin: "egde",
        domain: "us.iot.dreame.tech",
      },
      {
        short: "EG",
        name: "埃及",
        en: "Egypt",
        tel: "20",
        pinyin: "aj",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "SV",
        name: "萨尔瓦多",
        en: "El Salvador",
        tel: "503",
        pinyin: "sewd",
        domain: "us.iot.dreame.tech",
      },
      {
        short: "GQ",
        name: "赤道几内亚",
        en: "Equatorial Guinea",
        tel: "240",
        pinyin: "cdjny",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "ER",
        name: "厄立特里亚",
        en: "Eritrea",
        tel: "291",
        pinyin: "eltly",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "EE",
        name: "爱沙尼亚",
        en: "Estonia",
        tel: "372",
        pinyin: "asny",
        domain: "eu.iot.dreame.tech",
      },
      {
        short: "ET",
        name: "埃塞俄比亚",
        en: "Ethiopia",
        tel: "251",
        pinyin: "aseby",
        domain: "sg.iot.dreame.tech",
      },
    ],
    [
      {
        short: "FK",
        name: "福克兰群岛",
        en: "Falkland Islands",
        tel: "500",
        pinyin: "fklqd",
        domain: "us.iot.dreame.tech",
      },
      {
        short: "FO",
        name: "法罗群岛",
        en: "Faroe Islands",
        tel: "298",
        pinyin: "flqd",
        domain: "eu.iot.dreame.tech",
      },
      {
        short: "FJ",
        name: "斐济",
        en: "Fiji",
        tel: "679",
        pinyin: "fj",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "FI",
        name: "芬兰",
        en: "Finland",
        tel: "358",
        pinyin: "fl",
        domain: "eu.iot.dreame.tech",
      },
      {
        short: "FR",
        name: "法国",
        en: "France",
        tel: "33",
        pinyin: "fg",
        domain: "eu.iot.dreame.tech",
      },
      {
        short: "GF",
        name: "法属圭亚那",
        en: "French Guiana",
        tel: "594",
        pinyin: "fsgyn",
        domain: "eu.iot.dreame.tech",
      },
      {
        short: "PF",
        name: "法属波利尼西亚",
        en: "French polynesia",
        tel: "689",
        pinyin: "fsblnxy",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "TF",
        name: "法属南部领地",
        en: "French Southern Territories",
        tel: "262",
        pinyin: "fsnbld",
        domain: "sg.iot.dreame.tech",
      },
    ],
    [
      {
        short: "GA",
        name: "加蓬",
        en: "Gabon",
        tel: "241",
        pinyin: "jp",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "GM",
        name: "冈比亚",
        en: "Gambia",
        tel: "220",
        pinyin: "gby",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "GE",
        name: "格鲁吉亚",
        en: "Georgia",
        tel: "995",
        pinyin: "gljy",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "DE",
        name: "德国",
        en: "Germany",
        tel: "49",
        pinyin: "dg",
        domain: "eu.iot.dreame.tech",
      },
      {
        short: "GH",
        name: "加纳",
        en: "Ghana",
        tel: "233",
        pinyin: "jn",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "GI",
        name: "直布罗陀",
        en: "Gibraltar",
        tel: "350",
        pinyin: "zblt",
        domain: "eu.iot.dreame.tech",
      },
      {
        short: "GR",
        name: "希腊",
        en: "Greece",
        tel: "30",
        pinyin: "xl",
        domain: "eu.iot.dreame.tech",
      },
      {
        short: "GL",
        name: "格陵兰",
        en: "Greenland",
        tel: "299",
        pinyin: "gll",
        domain: "us.iot.dreame.tech",
      },
      {
        short: "GD",
        name: "格林纳达",
        en: "Grenada",
        tel: "1473",
        pinyin: "glnd",
        domain: "us.iot.dreame.tech",
      },
      {
        short: "GP",
        name: "瓜德罗普",
        en: "Guadeloupe",
        tel: "590",
        pinyin: "gdlp",
        domain: "us.iot.dreame.tech",
      },
      {
        short: "GU",
        name: "关岛",
        en: "Guam",
        tel: "1671",
        pinyin: "gd",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "GT",
        name: "危地马拉",
        en: "Guatemala",
        tel: "502",
        pinyin: "wdml",
        domain: "us.iot.dreame.tech",
      },
      {
        short: "GG",
        name: "根西岛",
        en: "Guernsey",
        tel: "447781",
        pinyin: "gxd",
        domain: "eu.iot.dreame.tech",
      },
      {
        short: "GN",
        name: "几内亚",
        en: "Guinea",
        tel: "224",
        pinyin: "jny",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "GW",
        name: "几内亚比绍",
        en: "Guinea-Bissau",
        tel: "245",
        pinyin: "jnybs",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "GY",
        name: "圭亚那",
        en: "Guyana",
        tel: "592",
        pinyin: "gyn",
        domain: "us.iot.dreame.tech",
      },
    ],
    [
      {
        short: "HT",
        name: "海地",
        en: "Haiti",
        tel: "509",
        pinyin: "hd",
        domain: "us.iot.dreame.tech",
      },
      {
        short: "HN",
        name: "洪都拉斯",
        en: "Honduras",
        tel: "504",
        pinyin: "hdls",
        domain: "us.iot.dreame.tech",
      },
      {
        short: "HK",
        name: "中国香港特别行政区",
        en: "Hong Kong（China）",
        tel: "852",
        pinyin: "zgxgtbhzq",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "HU",
        name: "匈牙利",
        en: "Hungary",
        tel: "36",
        pinyin: "xyl",
        domain: "eu.iot.dreame.tech",
      },
    ],
    [
      {
        short: "IS",
        name: "冰岛",
        en: "Iceland",
        tel: "354",
        pinyin: "bd",
        domain: "eu.iot.dreame.tech",
      },
      {
        short: "IN",
        name: "印度",
        en: "India",
        tel: "91",
        pinyin: "yd",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "ID",
        name: "印度尼西亚",
        en: "Indonesia",
        tel: "62",
        pinyin: "ydnxy",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "IR",
        name: "伊朗",
        en: "Iran",
        tel: "98",
        pinyin: "yl",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "IQ",
        name: "伊拉克",
        en: "Iraq",
        tel: "964",
        pinyin: "ylk",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "IE",
        name: "爱尔兰",
        en: "Ireland",
        tel: "353",
        pinyin: "ael",
        domain: "eu.iot.dreame.tech",
      },
      {
        short: "IM",
        name: "马恩岛",
        en: "Isle of Man",
        tel: "447624",
        pinyin: "med",
        domain: "eu.iot.dreame.tech",
      },
      {
        short: "IL",
        name: "以色列",
        en: "Israel",
        tel: "972",
        pinyin: "ysl",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "IT",
        name: "意大利",
        en: "Italy",
        tel: "39",
        pinyin: "ydl",
        domain: "eu.iot.dreame.tech",
      },
      {
        short: "CI",
        name: "科特迪瓦",
        en: "Ivory Coast (Côte d'Ivoire)",
        tel: "225",
        pinyin: "ktdw",
        domain: "sg.iot.dreame.tech",
      },
    ],
    [
      {
        short: "JM",
        name: "牙买加",
        en: "Jamaica",
        tel: "1876",
        pinyin: "ymj",
        domain: "us.iot.dreame.tech",
      },
      {
        short: "JP",
        name: "日本",
        en: "Japan",
        tel: "81",
        pinyin: "rb",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "JE",
        name: "泽西岛",
        en: "Jersey",
        tel: "441534",
        pinyin: "zxd",
        domain: "eu.iot.dreame.tech",
      },
      {
        short: "JO",
        name: "约旦",
        en: "Jordan",
        tel: "962",
        pinyin: "yd",
        domain: "sg.iot.dreame.tech",
      },
    ],
    [
      {
        short: "KZ",
        name: "哈萨克斯坦",
        en: "Kazakhstan",
        tel: "77",
        pinyin: "hskst",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "KE",
        name: "肯尼亚",
        en: "Kenya",
        tel: "254",
        pinyin: "kny",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "KI",
        name: "基里巴斯",
        en: "Kiribati",
        tel: "686",
        pinyin: "jlbs",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "XK",
        name: "科索沃",
        en: "Kosovo",
        tel: "383",
        pinyin: "ksw",
        domain: "eu.iot.dreame.tech",
      },
      {
        short: "KW",
        name: "科威特",
        en: "Kuwait",
        tel: "965",
        pinyin: "kwt",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "KG",
        name: "吉尔吉斯斯坦",
        en: "Kyrgyzstan",
        tel: "996",
        pinyin: "jejsst",
        domain: "sg.iot.dreame.tech",
      },
    ],
    [
      {
        short: "LA",
        name: "老挝",
        en: "Laos",
        tel: "856",
        pinyin: "lz",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "LV",
        name: "拉脱维亚",
        en: "Latvia",
        tel: "371",
        pinyin: "ltwy",
        domain: "eu.iot.dreame.tech",
      },
      {
        short: "LB",
        name: "黎巴嫩",
        en: "Lebanon",
        tel: "961",
        pinyin: "lbn",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "LS",
        name: "莱索托",
        en: "Lesotho",
        tel: "266",
        pinyin: "lst",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "LR",
        name: "利比里亚",
        en: "Liberia",
        tel: "231",
        pinyin: "lbly",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "LY",
        name: "利比亚",
        en: "Libya",
        tel: "218",
        pinyin: "lby",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "LI",
        name: "列支敦士登",
        en: "Liechtenstein",
        tel: "423",
        pinyin: "lzdsd",
        domain: "eu.iot.dreame.tech",
      },
      {
        short: "LT",
        name: "立陶宛",
        en: "Lithuania",
        tel: "370",
        pinyin: "ltw",
        domain: "eu.iot.dreame.tech",
      },
      {
        short: "LU",
        name: "卢森堡",
        en: "Luxembourg",
        tel: "352",
        pinyin: "lsb",
        domain: "eu.iot.dreame.tech",
      },
    ],
    [
      {
        short: "MO",
        name: "中国澳门特别行政区",
        en: "Macau (China)",
        tel: "853",
        pinyin: "zgamtbhzq",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "MG",
        name: "马达加斯加",
        en: "Madagascar",
        tel: "261",
        pinyin: "mdjsj",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "MW",
        name: "马拉维",
        en: "Malawi",
        tel: "265",
        pinyin: "mlw",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "MY",
        name: "马来西亚",
        en: "Malaysia",
        tel: "60",
        pinyin: "mlxy",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "MV",
        name: "马尔代夫",
        en: "Maldives",
        tel: "960",
        pinyin: "medf",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "ML",
        name: "马里",
        en: "Mali",
        tel: "223",
        pinyin: "ml",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "MT",
        name: "马耳他",
        en: "Malta",
        tel: "356",
        pinyin: "met",
        domain: "eu.iot.dreame.tech",
      },
      {
        short: "MH",
        name: "马绍尔群岛",
        en: "Marshall islands",
        tel: "692",
        pinyin: "mseqd",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "MQ",
        name: "马提尼克",
        en: "Martinique",
        tel: "596",
        pinyin: "mtnk",
        domain: "us.iot.dreame.tech",
      },
      {
        short: "MR",
        name: "毛里塔尼亚",
        en: "Mauritania",
        tel: "222",
        pinyin: "mltny",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "MU",
        name: "毛里求斯",
        en: "Mauritius",
        tel: "230",
        pinyin: "mlqs",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "YT",
        name: "马约特",
        en: "Mayotte",
        tel: "262639",
        pinyin: "myt",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "MX",
        name: "墨西哥",
        en: "Mexico",
        tel: "52",
        pinyin: "mxg",
        domain: "us.iot.dreame.tech",
      },
      {
        short: "FM",
        name: "密克罗尼西亚",
        en: "Micronesia",
        tel: "691",
        pinyin: "mklnxy",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "MD",
        name: "摩尔多瓦",
        en: "Moldova",
        tel: "373",
        pinyin: "medw",
        domain: "eu.iot.dreame.tech",
      },
      {
        short: "MC",
        name: "摩纳哥",
        en: "Monaco",
        tel: "377",
        pinyin: "mng",
        domain: "eu.iot.dreame.tech",
      },
      {
        short: "MN",
        name: "蒙古",
        en: "Mongolia",
        tel: "976",
        pinyin: "mg",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "ME",
        name: "黑山",
        en: "Montenegro",
        tel: "382",
        pinyin: "hs",
        domain: "eu.iot.dreame.tech",
      },
      {
        short: "MS",
        name: "蒙特塞拉特",
        en: "Montserrat",
        tel: "1664",
        pinyin: "mtslt",
        domain: "us.iot.dreame.tech",
      },
      {
        short: "MA",
        name: "摩洛哥",
        en: "Morocco",
        tel: "212",
        pinyin: "mlg",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "MZ",
        name: "莫桑比克",
        en: "Mozambique",
        tel: "258",
        pinyin: "msbk",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "MM",
        name: "缅甸",
        en: "Myanmar (Burma)",
        tel: "95",
        pinyin: "md",
        domain: "sg.iot.dreame.tech",
      },
    ],
    [
      {
        short: "NA",
        name: "纳米比亚",
        en: "Namibia",
        tel: "264",
        pinyin: "nmby",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "NR",
        name: "瑙鲁",
        en: "Nauru",
        tel: "674",
        pinyin: "nl",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "NP",
        name: "尼泊尔",
        en: "Nepal",
        tel: "977",
        pinyin: "nbe",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "NL",
        name: "荷兰",
        en: "Netherlands",
        tel: "31",
        pinyin: "hl",
        domain: "eu.iot.dreame.tech",
      },
      {
        short: "NC",
        name: "新喀里多尼亚",
        en: "New Caledonia",
        tel: "687",
        pinyin: "xkldny",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "NZ",
        name: "新西兰",
        en: "New Zealand",
        tel: "64",
        pinyin: "xxl",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "NI",
        name: "尼加拉瓜",
        en: "Nicaragua",
        tel: "505",
        pinyin: "njlg",
        domain: "us.iot.dreame.tech",
      },
      {
        short: "NE",
        name: "尼日尔",
        en: "Niger",
        tel: "227",
        pinyin: "nre",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "NG",
        name: "尼日利亚",
        en: "Nigeria",
        tel: "234",
        pinyin: "nrly",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "NU",
        name: "纽埃",
        en: "Niue",
        tel: "683",
        pinyin: "na",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "NF",
        name: "诺福克岛",
        en: "Norfolk Island",
        tel: "6723",
        pinyin: "nfkd",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "KP",
        name: "朝鲜",
        en: "North Korea",
        tel: "850",
        pinyin: "zx",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "MK",
        name: "马其顿",
        en: "North Macedonia",
        tel: "389",
        pinyin: "mqd",
        domain: "eu.iot.dreame.tech",
      },
      {
        short: "MP",
        name: "北马里亚纳群岛",
        en: "Northern Mariana Islands",
        tel: "1670",
        pinyin: "bmlynqd",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "NO",
        name: "挪威",
        en: "Norway",
        tel: "47",
        pinyin: "nw",
        domain: "eu.iot.dreame.tech",
      },
    ],
    [
      {
        short: "OM",
        name: "阿曼",
        en: "Oman",
        tel: "968",
        pinyin: "am",
        domain: "sg.iot.dreame.tech",
      },
    ],
    [
      {
        short: "PK",
        name: "巴基斯坦",
        en: "Pakistan",
        tel: "92",
        pinyin: "bjst",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "PW",
        name: "帕劳",
        en: "Palau",
        tel: "680",
        pinyin: "pl",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "PS",
        name: "巴勒斯坦",
        en: "Palestinian Territories",
        tel: "970",
        pinyin: "blst",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "PA",
        name: "巴拿马",
        en: "Panama",
        tel: "507",
        pinyin: "bnm",
        domain: "us.iot.dreame.tech",
      },
      {
        short: "PG",
        name: "巴布亚新几内亚",
        en: "Papua New Guinea",
        tel: "675",
        pinyin: "bbyxjny",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "PY",
        name: "巴拉圭",
        en: "Paraguay",
        tel: "595",
        pinyin: "blg",
        domain: "us.iot.dreame.tech",
      },
      {
        short: "PE",
        name: "秘鲁",
        en: "Peru",
        tel: "51",
        pinyin: "ml",
        domain: "us.iot.dreame.tech",
      },
      {
        short: "PH",
        name: "菲律宾",
        en: "Philippines",
        tel: "63",
        pinyin: "flb",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "PN",
        name: "皮特凯恩群岛",
        en: "Pitcairn Islands",
        tel: "64",
        pinyin: "ptkeqd",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "PL",
        name: "波兰",
        en: "Poland",
        tel: "48",
        pinyin: "bl",
        domain: "eu.iot.dreame.tech",
      },
      {
        short: "PT",
        name: "葡萄牙",
        en: "Portugal",
        tel: "351",
        pinyin: "pty",
        domain: "eu.iot.dreame.tech",
      },
      {
        short: "PR",
        name: "波多黎各",
        en: "Puerto Rico",
        tel: "1939",
        pinyin: "bdlg",
        domain: "us.iot.dreame.tech",
      },
    ],
    [
      {
        short: "QA",
        name: "卡塔尔",
        en: "Qatar",
        tel: "974",
        pinyin: "kte",
        domain: "sg.iot.dreame.tech",
      },
    ],
    [
      {
        short: "RO",
        name: "罗马尼亚",
        en: "Romania",
        tel: "40",
        pinyin: "lmny",
        domain: "eu.iot.dreame.tech",
      },
      {
        short: "RU",
        name: "俄罗斯",
        en: "Russia",
        tel: "7",
        pinyin: "els",
        domain: "ru.iot.dreame.tech",
      },
      {
        short: "RW",
        name: "卢旺达",
        en: "Rwanda",
        tel: "250",
        pinyin: "lwd",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "RE",
        name: "留尼汪",
        en: "Réunion",
        tel: "262",
        pinyin: "lnw",
        domain: "sg.iot.dreame.tech",
      },
    ],
    [
      {
        short: "BL",
        name: "圣巴泰勒米",
        en: "Saint Barthélemy",
        tel: "590",
        pinyin: "sbtlm",
        domain: "us.iot.dreame.tech",
      },
      {
        short: "SH",
        name: "圣赫勒拿",
        en: "Saint Helena",
        tel: "290",
        pinyin: "shln",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "KN",
        name: "圣基茨和尼维斯",
        en: "Saint Kitts and Nevis",
        tel: "1869",
        pinyin: "sjchnws",
        domain: "us.iot.dreame.tech",
      },
      {
        short: "LC",
        name: "圣卢西亚",
        en: "Saint Lucia",
        tel: "1758",
        pinyin: "slxy",
        domain: "us.iot.dreame.tech",
      },
      {
        short: "MF",
        name: "法属圣马丁",
        en: "Saint Martin (France)",
        tel: "590",
        pinyin: "fssmd",
        domain: "eu.iot.dreame.tech",
      },
      {
        short: "PM",
        name: "圣皮埃尔和密克隆群岛",
        en: "Saint Pierre and Miquelon",
        tel: "508",
        pinyin: "spaehmklqd",
        domain: "us.iot.dreame.tech",
      },
      {
        short: "VC",
        name: "圣文森特和格林纳丁斯",
        en: "Saint Vincent and The Grenadines",
        tel: "1784",
        pinyin: "swsthglnds",
        domain: "us.iot.dreame.tech",
      },
      {
        short: "WS",
        name: "萨摩亚",
        en: "Samoa",
        tel: "685",
        pinyin: "smy",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "SM",
        name: "圣马力诺",
        en: "San Marino",
        tel: "378",
        pinyin: "smln",
        domain: "eu.iot.dreame.tech",
      },
      {
        short: "SA",
        name: "沙特阿拉伯",
        en: "Saudi Arabia",
        tel: "966",
        pinyin: "stalb",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "SN",
        name: "塞内加尔",
        en: "Senegal",
        tel: "221",
        pinyin: "snje",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "RS",
        name: "塞尔维亚",
        en: "Serbia",
        tel: "381",
        pinyin: "sewy",
        domain: "eu.iot.dreame.tech",
      },
      {
        short: "SC",
        name: "塞舌尔",
        en: "Seychelles",
        tel: "248",
        pinyin: "sse",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "SL",
        name: "塞拉利昂",
        en: "Sierra Leone",
        tel: "232",
        pinyin: "slla",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "SG",
        name: "新加坡",
        en: "Singapore",
        tel: "65",
        pinyin: "xjp",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "SK",
        name: "斯洛伐克",
        en: "Slovakia",
        tel: "421",
        pinyin: "slfk",
        domain: "eu.iot.dreame.tech",
      },
      {
        short: "SI",
        name: "斯洛文尼亚",
        en: "Slovenia",
        tel: "386",
        pinyin: "slwny",
        domain: "eu.iot.dreame.tech",
      },
      {
        short: "SB",
        name: "所罗门群岛",
        en: "Solomon Islands",
        tel: "677",
        pinyin: "slmqd",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "SO",
        name: "索马里",
        en: "Somalia",
        tel: "252",
        pinyin: "sml",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "ZA",
        name: "南非",
        en: "South Africa",
        tel: "27",
        pinyin: "nf",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "GS",
        name: "南乔治亚和南桑威奇群岛",
        en: "South Georgia and the South Sandwich Islands",
        tel: "500",
        pinyin: "nqzyhnswqqd",
        domain: "us.iot.dreame.tech",
      },
      {
        short: "KR",
        name: "韩国",
        en: "South Korea",
        tel: "82",
        pinyin: "hg",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "SS",
        name: "南苏丹",
        en: "South Sudan",
        tel: "211",
        pinyin: "nsd",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "ES",
        name: "西班牙",
        en: "Spain",
        tel: "34",
        pinyin: "xby",
        domain: "eu.iot.dreame.tech",
      },
      {
        short: "LK",
        name: "斯里兰卡",
        en: "Sri Lanka",
        tel: "94",
        pinyin: "sllk",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "SD",
        name: "苏丹",
        en: "Sudan",
        tel: "249",
        pinyin: "sd",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "SR",
        name: "苏里南",
        en: "Suriname",
        tel: "597",
        pinyin: "sln",
        domain: "us.iot.dreame.tech",
      },
      {
        short: "SJ",
        name: "斯瓦尔巴和扬马延",
        en: "Svalbard and Jan Mayen",
        tel: "4779",
        pinyin: "swebhymy",
        domain: "eu.iot.dreame.tech",
      },
      {
        short: "SZ",
        name: "斯威士兰",
        en: "Swaziland",
        tel: "268",
        pinyin: "swsl",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "SE",
        name: "瑞典",
        en: "Sweden",
        tel: "46",
        pinyin: "rd",
        domain: "eu.iot.dreame.tech",
      },
      {
        short: "CH",
        name: "瑞士",
        en: "Switzerland",
        tel: "41",
        pinyin: "rs",
        domain: "eu.iot.dreame.tech",
      },
      {
        short: "SY",
        name: "叙利亚",
        en: "Syria",
        tel: "963",
        pinyin: "xly",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "ST",
        name: "圣多美和普林西比",
        en: "São Tomé and Príncipe",
        tel: "239",
        pinyin: "sdmhplxb",
        domain: "sg.iot.dreame.tech",
      },
    ],
    [
      {
        short: "TW",
        name: "中国台湾",
        en: "Taiwan (China)",
        tel: "886",
        pinyin: "zgtw",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "TJ",
        name: "塔吉克斯坦",
        en: "Tajikistan",
        tel: "992",
        pinyin: "tjkst",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "TZ",
        name: "坦桑尼亚",
        en: "Tanzania",
        tel: "255",
        pinyin: "tsny",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "TH",
        name: "泰国",
        en: "Thailand",
        tel: "66",
        pinyin: "tg",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "TG",
        name: "多哥",
        en: "Togo",
        tel: "228",
        pinyin: "dg",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "TK",
        name: "托克劳",
        en: "Tokelau",
        tel: "690",
        pinyin: "tkl",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "TO",
        name: "汤加",
        en: "Tonga",
        tel: "676",
        pinyin: "tj",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "TT",
        name: "特立尼达和多巴哥",
        en: "Trinidad and Tobago",
        tel: "1868",
        pinyin: "tlndhdbg",
        domain: "us.iot.dreame.tech",
      },
      {
        short: "TA",
        name: "特里斯坦-达库尼亚群岛",
        en: "Tristan da Cunha",
        tel: "290",
        pinyin: "tlstdknyqd",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "TN",
        name: "突尼斯",
        en: "Tunisia",
        tel: "216",
        pinyin: "tns",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "TR",
        name: "土耳其",
        en: "Turkey",
        tel: "90",
        pinyin: "teq",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "TM",
        name: "土库曼斯坦",
        en: "Turkmenistan",
        tel: "993",
        pinyin: "tkmst",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "TC",
        name: "特克斯和凯科斯群岛",
        en: "Turks and Caicos Islands",
        tel: "1649",
        pinyin: "tkshkksqd",
        domain: "us.iot.dreame.tech",
      },
      {
        short: "TV",
        name: "图瓦卢",
        en: "Tuvalu",
        tel: "688",
        pinyin: "twl",
        domain: "sg.iot.dreame.tech",
      },
    ],
    [
      {
        short: "UG",
        name: "乌干达",
        en: "Uganda",
        tel: "256",
        pinyin: "wgd",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "UA",
        name: "乌克兰",
        en: "Ukraine",
        tel: "380",
        pinyin: "wkl",
        domain: "eu.iot.dreame.tech",
      },
      {
        short: "AE",
        name: "阿拉伯联合酋长国",
        en: "United Arab Emirates",
        tel: "971",
        pinyin: "alblhqcg",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "GB",
        name: "英国",
        en: "United Kingdom",
        tel: "44",
        pinyin: "yg",
        domain: "eu.iot.dreame.tech",
      },
      {
        short: "US",
        name: "美国",
        en: "United States",
        tel: "1",
        pinyin: "mg",
        domain: "us.iot.dreame.tech",
      },
      {
        short: "UM",
        name: "美国本土外小岛屿",
        en: "United States Minor Outlying Islands",
        tel: "1",
        pinyin: "mgbtwxdy",
        domain: "us.iot.dreame.tech",
      },
      {
        short: "UY",
        name: "乌拉圭",
        en: "Uruguay",
        tel: "598",
        pinyin: "wlg",
        domain: "us.iot.dreame.tech",
      },
      {
        short: "VI",
        name: "美属维尔京群岛",
        en: "US Virgin Islands",
        tel: "1340",
        pinyin: "mswejqd",
        domain: "us.iot.dreame.tech",
      },
      {
        short: "UZ",
        name: "乌兹别克斯坦",
        en: "Uzbekistan",
        tel: "998",
        pinyin: "wzbkst",
        domain: "sg.iot.dreame.tech",
      },
    ],
    [
      {
        short: "VU",
        name: "瓦努阿图",
        en: "Vanuatu",
        tel: "678",
        pinyin: "wnat",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "VA",
        name: "梵蒂冈",
        en: "Vatican",
        tel: "3906",
        pinyin: "fdg",
        domain: "eu.iot.dreame.tech",
      },
      {
        short: "VE",
        name: "委内瑞拉",
        en: "Venezuela",
        tel: "58",
        pinyin: "wnrl",
        domain: "us.iot.dreame.tech",
      },
      {
        short: "VN",
        name: "越南",
        en: "Vietnam",
        tel: "84",
        pinyin: "yn",
        domain: "sg.iot.dreame.tech",
      },
    ],
    [
      {
        short: "WF",
        name: "瓦利斯和富图纳",
        en: "Wallis and Futuna",
        tel: "681",
        pinyin: "wlshftn",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "EH",
        name: "西撒哈拉",
        en: "Western Sahara",
        tel: "212",
        pinyin: "xshl",
        domain: "sg.iot.dreame.tech",
      },
    ],
    [
      {
        short: "YE",
        name: "也门",
        en: "Yemen",
        tel: "967",
        pinyin: "ym",
        domain: "sg.iot.dreame.tech",
      },
    ],
    [
      {
        short: "ZM",
        name: "赞比亚",
        en: "Zambia",
        tel: "260",
        pinyin: "zby",
        domain: "sg.iot.dreame.tech",
      },
      {
        short: "ZW",
        name: "津巴布韦",
        en: "Zimbabwe",
        tel: "263",
        pinyin: "jbbw",
        domain: "sg.iot.dreame.tech",
      },
    ],
    [
      {
        short: "AX",
        name: "奥兰群岛",
        en: "Åland Islands",
        tel: "35818",
        pinyin: "alqd",
        domain: "eu.iot.dreame.tech",
      },
    ],
  ],
  langList: [
    {
      name: "中文简体",
      value: "zh",
    },
    {
      name: "English",
      value: "en",
    },
    {
      name: "русский",
      value: "ru",
    },
    {
      name: "繁體中文(台灣)",
      value: "zh-tw",
    },
    {
      name: "繁體中文(香港)",
      value: "zh-hk",
    },
    {
      name: "Deutsch",
      value: "de",
    },

    {
      name: '한국어',
      value: 'ko'
    },
    {
      name: '日本語',
      value: 'ja'
    },
    {
      name: 'français',
      value: 'fr'
    },
    {
      name: 'español',
      value: 'es'
    },
    {
      name: 'italiano',
      value: 'it'
    },
    {
      name: 'polski',
      value: 'pl'
    },
    {
      name: 'Türkçe',
      value: 'tr'
    },
    {
      name: 'Tiếng Việt',
      value: 'vi'
    },
    {
      name: 'ไทย',
      value: 'th'
    },
    {
      name: 'Bahasa Indonesia',
      value: 'id'
    },
    {
      name: 'Українська Мова',
      value: 'uk'
    },
  ],
  // basicUrl: "http://dev.iot.dreame.tech:30080/",
  // 这里是线上环境
  voicecnUrl: 'https://smarthomecn.dreame.tech/dreame-auth/',
  voiceUrl: 'https://smarthome.dreame.tech/dreame-auth/',
  // 这里是线下环境
  // voicecnUrl: 'https://smarthomecntest.dreame.tech/dreame-auth/',
  // voiceUrl: 'https://smarthometest.dreame.tech/dreame-auth/',
  // voiceUrl: 'https://yin.dreame.tech/dreame-auth/',
  // voicecnUrl: 'https://yin.dreame.tech/dreame-auth/'
}
